import { FC, MouseEventHandler } from "react";
import { useLocation } from "react-router-dom";
import { SideBarItemType } from "@/types/view";
import { AppLink, AppMenuItem } from "@/components/common";
import { MenuItemProps } from "@mui/material";
import styled from "@emotion/styled";

type MainMenuItemProps = MenuItemProps & {
  menuItem: SideBarItemType;
  onItemClick?: () => void;
};

const MenuItemStyled = styled(AppMenuItem)({
  width: 250,

  "&.active": {
    background: "rgba(0, 0, 0, 0.1)",
  },
});

const MenuItem: FC<MainMenuItemProps> = ({ menuItem, onItemClick, ...otherProps }) => {
  const location = useLocation();

  const handleClick: MouseEventHandler<HTMLLIElement> = e => {
    if (onItemClick) onItemClick();
    if (menuItem.onClick) menuItem.onClick(e);
  };

  return (
    <AppLink to={menuItem.url} key={menuItem.key} underline="none" color="inherit">
      <MenuItemStyled
        className={location.pathname === menuItem.url ? "active" : ""}
        startIcon={menuItem.icon}
        text={menuItem.title}
        onClick={handleClick}
        {...otherProps}
      />
    </AppLink>
  );
};

export default MenuItem;
